<style lang="scss">
img{
    vertical-align: middle;
    height: 20px;
}
.line-24{
    line-height: 24px;
}
.base-title{
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #2d8cf0;
    color: #fff;
}
</style>

<template>
   <div class="bg-fff shadow ">
        <header class="base-title font-bold">基本信息</header>
        <Form :label-width="120" ref="form" class="margin-15 clearfix">
            <Col span="24">
                <Col span="12">
                    <FormItem label='订单号'>
                        <span class="font-weight">{{combaseInfo.orderId}} / {{combaseInfo.orderNo}}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='订单类型'>
                        <div style="width:65px;display:inline-block" v-html="orderTypes[combaseInfo.orderType]"></div>

                        <img class="margin-right-5" v-show="combaseInfo.isCelebrity=='Y'" src="/picture/hongren.png">
                        <img class="margin-right-5" v-show="combaseInfo.isSample=='Y'" src="/picture/yangpin.png">
                        <img class="margin-right-5" v-show="combaseInfo.isReshipment=='Y'" src="/picture/bufa.png">
                        <img class="margin-right-5" v-show="combaseInfo.isAddition=='Y'" src="/picture/lipin.png">
                        <img class="margin-right-5" v-show="combaseInfo.isDismantlement=='Y' && combaseInfo.parentId==0" src="/picture/chaifu.png">
                        <img class="margin-right-5" v-show="combaseInfo.isDismantlement=='Y' && combaseInfo.parentId!=0" src="/picture/chaizi.png">
                        <span v-show="combaseInfo.isPrime=='Y'" class="b2cfont-italic b2ccolor-info">Prime</span>
                        <span v-show="combaseInfo.isOnsite=='Y'" class="b2cfont-italic b2ccolor-content">Onsite</span>
                        <span v-show="combaseInfo.isBusinessOrder=='Y'" class="b2cfont-italic b2ccolor-error">Business</span>
                        <span v-show="combaseInfo.shipmentType==1" class="b2cfont-italic b2ccolor-warning">Store</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='渠道账号'>
                        <span class="font-weight">{{combaseInfo.channelFlag}}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='发货类型'>
                       <span class="font-weight">{{combaseInfo.fulfillmentChannel}}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='创建时间'>
                        <span class="font-weight">{{combaseInfo.channelCreated}}</span>
                    </FormItem>
                </Col>

                <Col span="12">
                    <FormItem label='销售金额'>
                        <span class="font-weight">{{combaseInfo.amount}} {{combaseInfo.currencyCode}}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='订单状态'>

                        <span class="font-weight"><div v-html="orderStatus[combaseInfo.orderStatus]"></div></span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='采购单号'>
                        <span class="font-weight">{{combaseInfo.poNumber}}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label='客户邮箱'>
                        <span class="font-weight">{{combaseInfo.buyEmail}}</span>
                    </FormItem>
                </Col>
            </Col>

        </Form>
    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
export default {
    props: ['combaseInfo', 'type', 'status', 'parentId'],
    data() {
        return {
            orderTypes:{
                'normally':'<div class="b2ccolor-dark-primary font-weight span-padding line-24">正常销售</div>',
                'celebrity':'<div class="b2ccolor-error font-weight span-padding line-24">展示订单</div>',
                'distribution':'<div class="b2ccolor-success font-weight span-padding line-24">分销订单</div>',
                'brush':'<div class="b2ccolor-warning font-weight span-padding line-24">刷评订单</div>',
                'DELIVERY':'<div class="b2ccolor-warning font-weight span-padding line-24">发货订单</div>'
            },
            orderStatus:{
                'pending':'<div class="b2cspan-error span-padding line-24">未支付</div>',
                'unshipped':'<div class="b2cspan-middle-content span-padding line-24">未发货</div>',
                'approved':'<div class="b2cspan-success span-padding line-24">已审核</div>',
                'assigned':'<div class="b2cspan-primary span-padding line-24">已分配</div>',
                'picked':'<div class="b2cspan-info span-padding line-24">已配货</div>',
                'shipped':'<div class="b2cspan-light-content span-padding line-24">已发货</div>',
                'canceled':'<div class="b2cspan-warning span-padding line-24">已取消</div>',
                'refunded':'<div class="b2cspan-dark-primary span-padding line-24">已退款</div>',
            }
        }
    },
    mounted() {
    },
    computed: {
        ...mapState('boss',['products']),
        ...mapGetters('boss',['warehouses']),

    },
    methods: {

    },
    filters:{
        filterFillChannel(val){
            let type;
            switch (val) {
                case '0': type = 'MFN'; break;
                case '1': type = 'AFM'; break;
            }
            return type ;
        },
    }

}
</script>

